export default __webpack_public_path__ + "static/media/325.c4400c2b.png";